<script setup>
// RM-359: right after a submit that RM reviews first, the member sees why the
// request isn't with the restaurant yet — the server's copy (the RM AI replies
// table, Access → Reservation requests), shown once and dismissible.
import { storeToRefs } from 'pinia'
import { useReservationsStore } from '@/stores/reservations.store'

const reservationsStore = useReservationsStore()
const { lastApprovalNotice } = storeToRefs(reservationsStore)

const dismiss = () => {
  reservationsStore.lastApprovalNotice = null
}
</script>

<template>
  <VAlert
    v-if="lastApprovalNotice?.text"
    class="approval-notice"
    type="info"
    variant="tonal"
    density="comfortable"
    closable
    title="Request submitted - Pending RM Review"
    @click:close="dismiss"
  >
    {{ lastApprovalNotice.text }}
  </VAlert>
</template>

<style scoped>
.approval-notice {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.45;
}

.approval-notice :deep(.v-alert-title) {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  hyphens: none;
}
</style>
